import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { envValue } from '../../../config/envUtils';
import Dropzone from 'react-dropzone';
import { FileService } from '../../services/fileUpload/uploadFile';
import FileTransportProxy from './FileTransportProxy/FileTransportProxy';

const SOURCEURL = envValue('SOURCEURL');

class AssetUploader extends Component {
    static propTypes = {
        onError: PropTypes.func,
        onUploadStart: PropTypes.func,
        onComplete: PropTypes.func,
        filter: PropTypes.string,
        multiple: PropTypes.bool
    };
    static defaultProps = {
        onError: () => {},
        onUploadStart: () => {},
        onComplete: () => {},
        filter: '.*',
        multiple: true
    };

    constructor(props) {
        super(props);
        this.onUploadStart = this.onUploadStart.bind(this);
        this.onOpen = this.onOpen.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
    }

    componentDidMount() {}

    setRef(ref) {
        this.fileTransportProxy = ref;
    }

    completeHandler() {
        if (this.props.onComplete) {
            this.props.onComplete();
        }
    }
    onOpen() {
        this.props.onOpen && this.props.onOpen();
    }
    onUploadStart() {
        this.props.onUploadStart && this.props.onUploadStart();
    }

    errorHandler(error) {
        if (this.props.onError) {
            this.props.onError(error);
        }
    }
    onSuccess(result) {
        this.props.onSuccess && this.props.onSuccess(result);
    }
    progressHandler(progress) {
        if (this.props.onProgress && typeof this.props.onProgress === 'function') {
            this.props.onProgress(progress);
        }
    }
    render() {
        return (
            <FileTransportProxy
                onUploadStart={this.onUploadStart}
                onOpen={this.onOpen}
                onRefresh={this.props.onRefresh}
                onResetErrors={this.props.onResetErrors}
                onComplete={result => {
                    this.completeHandler(result);
                }}
                onError={error => {
                    this.errorHandler(error);
                }}
                onProgress={progress => {
                    this.progressHandler(progress);
                }}
                filter={this.props.filter}
                setRef={ref => this.setRef(ref)}
                store={this.props.store}
                metadata={this.props.metadata}
                disabled={!this.props.hasAccess}
                onSuccess={this.onSuccess}
                multiple={this.props.multiple}
            />
        );
    }
}
const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        level: state.app.selected.level,
        assets: state.app.selected.assets
    };
};

AssetUploader.defaultProps = {
    filter: '.*',
    metadata: {},
    hasAccess: true
};

AssetUploader.propTypes = {
    children: PropTypes.element,
    accept: PropTypes.string,
    onProgress: PropTypes.func,
    onOpen: PropTypes.func,
    onError: PropTypes.func,
    onComplete: PropTypes.func,
    store: PropTypes.object,
    metadata: PropTypes.object,
    hasAccess: PropTypes.bool
};

export default connect(mapStateToProps)(AssetUploader);



// WEBPACK FOOTER //
// ./src/components/widgets/AssetUploader.js